import styled from "styled-components";
import { FaRegEnvelope, FaRegBuilding } from "react-icons/fa";
import { Button, MOBILE, EXTRA_LARGE } from "@minerva-analytics/pantheon";
import {
  BODY_TEXT_COLOR,
  CONTACT_FONT,
  SECONDARY_COLOR,
  CONTACT_CARD,
  BACKGROUND_COLOR,
  HOVER_COLOR,
  SECONDARY_BACKGROUND_COLOR,
  TERTIARY_BACKGROUND_COLOR,
} from "../../theme";

const ContactUsContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: column;
`;

const CardContent = styled.div`
  width: 87%;
  margin: 0 auto;
`;

const IconText = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const MailIcon = styled(FaRegEnvelope)`
  color: ${BACKGROUND_COLOR};
  height: 1.3rem;
  width: 1.3rem;
  margin-right: 1rem;
  overflow: visible;
  border-radius: 50%;
  padding: 0.7rem;
  background-color: ${SECONDARY_BACKGROUND_COLOR};
`;
const BuildingIcon = styled(FaRegBuilding)`
  color: ${BACKGROUND_COLOR};
  height: 1.3rem;
  width: 1.3rem;
  margin-right: 1rem;
  overflow: visible;
  border-radius: 50%;
  padding: 0.7rem;
  background-color: ${SECONDARY_BACKGROUND_COLOR};
`;

const SubscribeButton = styled(Button)`
  &&& {
    background-color: ${SECONDARY_COLOR};
    color: ${BACKGROUND_COLOR};
    font-family: ${CONTACT_FONT};

    padding: 0.55rem 2.5rem;
    font-weight: 600;

    @media (max-width: ${MOBILE}) {
      width: 100%;
      padding: 0.55rem 0;
    }
    :hover {
      background-color: ${HOVER_COLOR};
    }
  }
`;

const ContactText = styled.p`
  color: ${BODY_TEXT_COLOR};
  font-family: ${CONTACT_FONT};
  font-size: 18px;
  font-weight: bold;
  line-height: 33px;
  letter-spacing: 0.68px;
  max-width: 80%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
`;

const ContactCard = styled.div`
  border-top: 1rem solid ${TERTIARY_BACKGROUND_COLOR};
  background-color: ${CONTACT_CARD};
  max-width: 40rem;
  width: 90%;
  margin-bottom: 2.5rem;
  box-sizing: border-box;
  padding-bottom: 2.5rem;
  padding-top: 0;
  display: inline-block;
  min-height: 400px;
  min-width: 250px;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 10px 0px;
`;

const Background = styled.div`
  background-color: ${BACKGROUND_COLOR};
  @media (min-width: ${EXTRA_LARGE}) {
    position: absolute;
    top: 0px;
    height: 100%;
    right: 0px;
    width: 100%;
  }
  z-index: -1;
`;

export {
  ContactUsContainer,
  IconText,
  MailIcon,
  BuildingIcon,
  SubscribeButton,
  CardContent,
  ContactText,
  ContactCard,
  Background,
};
